import React from 'react';
import PropTypes from 'prop-types';
import { get, cloneDeep, isEmpty, set, find } from 'lodash';
import BookingOvertimeForm from './forms/booking-overtime-form';
import { TosCTAdisclaimer } from 'shared-components/terms/cta-disclaimer';
import { OvertimeErrorModal } from './overtime-error-modal';
import ModalManager from '../elements-modal/modal-manager';
import { overtimeQuote, createOvertime } from '../app-main/actions/contracts';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { BookingSummary } from '../elements-summaries/booking-summary/BookingSummary';

class BookingOvertimeMain extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.state = {
      isProcessing: false,
      displayError: '',
      whichModal: '',
      modalErrorMsg: ''
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.submitOvertime = this.submitOvertime.bind(this);
    this.submitOvertimeCb = this.submitOvertimeCb.bind(this);
    this.prepareOvertime = this.prepareOvertime.bind(this);
    this.prepareOvertimeCb = this.prepareOvertimeCb.bind(this);
    this.cancelAction = this.cancelAction.bind(this);
  }

  componentDidMount () {
    const { accessToken, hoursValue = null, multiplierValue = null, booking, dispatch } = this.props;
    const bookingID = get(booking, '_id', '');
    const guestID = get(booking, 'guest_id', '');
    const hostID = get(booking, 'host_id', '');
    const payload = {
      host_sso_id: hostID,
      guest_sso_id: guestID,
      type: 'HOST_ADJUST',
      items: [{
        type: 'ADJUSTMENT',
        info: {
          rate: 0,
          duration: 0,
          multiplier: 1,
          category: 'OVERTIME',
          vendor_sso_id: hostID
        }
      }]
    };

    dispatch(overtimeQuote(payload, bookingID, accessToken, (response) => {
      if (400 === response.statusCode || response.error) {
        this.toggleModal('overtimeModal', response.error);
      }
      return analyticsIntegrations.overtimeFormViewed(booking);
    }));
  }

  toggleModal (whichModal, errorMsg) {
    this.setState({ whichModal, modalErrorMsg: errorMsg });
  }

  overtimeProperties (response) {
    const overtimeContract = find(get(response, 'pending.children', []), { type: 'ADJUSTMENT' });

    const overtimeID = get(overtimeContract, '_id', '')
    const overtimeDetails = get(overtimeContract, 'meta.info', {});
    const { duration = 0, rate = 0, multiplier = 0, amount = 0 } = overtimeDetails;

    const updateDifference = get(response, 'pending.master.calculations.update_difference', {});
    const { additional_payment = 0, guest_fee = 0, host_fee = 0, payout = 0 } = updateDifference;

    const hostFeePercent = get(response, 'pending.master.calculations.host.fee_percent', 0);
    const guestFeePercent = get(response, 'pending.master.calculations.guest.fee_percent', 0);

    const properties = {
      overtime_id: overtimeID,
      overtime_duration: duration,
      overtime_hourly_price: rate,
      overtime_price_multiple: multiplier,
      overtime_guest_charge: additional_payment,
      overtime_host_payout: -payout,
      overtime_subtotal: amount,
      overtime_guest_fee_pct: guestFeePercent,
      overtime_host_fee_pct: hostFeePercent,
      overtime_guest_fee_total: guest_fee,
      overtime_host_fee_total: -host_fee
    };

    return properties;
  }

  prepareOvertime (event, newValue, previousValue, name) {
    const { accessToken, hoursValue = null, multiplierValue = null, booking, dispatch } = this.props;

    const bookingID = get(booking, '_id', '');
    const guestID = get(booking, 'guest_id', '');
    const hostID = get(booking, 'host_id', '');

    const currentMultiplierValue = 'multiplier' === name ? newValue : multiplierValue
    const currentHoursValue = 'hours' === name ? newValue : hoursValue

    if (!currentMultiplierValue || !currentHoursValue) { return; }

    const listingPrice = get(booking, 'rate_details.rate', 0);
    const multiplierPayloadValue = currentMultiplierValue === 'default' ? 1.5 : 1;

    const payload = {
      host_sso_id: hostID,
      guest_sso_id: guestID,
      type: 'HOST_ADJUST',
      items: [{
        type: 'ADJUSTMENT',
        info: {
          rate: listingPrice,
          duration: currentHoursValue,
          multiplier: multiplierPayloadValue,
          category: 'OVERTIME',
          vendor_sso_id: hostID
        }
      }]
    };

    return dispatch(overtimeQuote(payload, bookingID, accessToken, (response) => {
      this.prepareOvertimeCb(response);
    }));
  }

  prepareOvertimeCb (response) {
    if (response.error) {
      this.setState({ displayError: this.props.intl.formatMessage({ id: 'inbox_bookingID_overtime.booking_overtime_main.something_wrong', defaultMessage: 'Something went wrong, please try again.' }) });
    }
  }

  submitOvertime (formValues, formCallback) {
    this.setState({ isProcessing: true });
    const { hours, multiplier } = formValues;

    const { accessToken, booking, dispatch } = this.props;

    const bookingID = get(booking, '_id', '');
    const guestID = get(booking, 'guest_id', '');
    const hostID = get(booking, 'host_id', '');

    const listingPrice = get(booking, 'rate_details.rate', 0);
    const multiplierValue = multiplier === 'default' ? 1.5 : 1;

    const payload = {
      host_sso_id: hostID,
      guest_sso_id: guestID,
      type: 'HOST_ADJUST',
      items: [{
        type: 'ADJUSTMENT',
        info: {
          rate: listingPrice,
          duration: hours,
          multiplier: multiplierValue,
          category: 'OVERTIME',
          vendor_sso_id: hostID
        }
      }]
    };

    return dispatch(createOvertime(payload, bookingID, accessToken, formCallback));
  }

  submitOvertimeCb (response) {
    if (200 === response.statusCode) {
      const { booking } = this.props;
      analyticsIntegrations.overtimeFormSubmitted(booking, this.overtimeProperties(response));
      return this.context.router.push({ pathname: `/inbox/${booking._id}`, state: 'overtimeSuccess' });
    }

    return this.setState({
      displayError: this.props.intl.formatMessage({ id: 'inbox_bookingID_overtime.booking_overtime_main.something_wrong_cb', defaultMessage: 'Something went wrong, please try again.' }),
      isProcessing: false
    });
  }

  termsDisclaimer () {
    return (
      <div className="col-xs-12">
        <hr className="margin-sm-bottom" />
        <TosCTAdisclaimer location="requestBkg" buttonLabel={ this.props.intl.formatMessage({ id: 'inbox_bookingID_overtime.booking_overtime_main.submit_overtime', defaultMessage: 'Submit Overtime' }) } />
      </div>
    );
  }

  cancelAction () {
    const bookingID = get(this.props, 'booking._id', '');
    return this.context.router.push({ pathname: `/inbox/${bookingID}` });
  }

  render () {
    const { whichModal, modalErrorMsg, isProcessing, displayError } = this.state;
    const {
      spaceRentalContract,
      booking,
      profile,
      intl
    } = this.props;
    const listingPrice = get(booking, 'rate_details.rate', 0);
    const listing = get(spaceRentalContract, 'meta.listing', {});
    const currency = get(listing, 'prices[0].currency', 0);
    const hostID = get(booking, 'host_id', '');
    const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();

    const activityDetailBooking = cloneDeep(booking);
    if (!isEmpty(activityDetailBooking)) {
      activityDetailBooking.payment = {};
      activityDetailBooking.list_price = {};
      activityDetailBooking.payout = {};
      activityDetailBooking.view_as = 'HOST';
      activityDetailBooking.listing = listing;
      set(activityDetailBooking, 'guest.sso_id', get(booking, 'guest_id'));
      delete activityDetailBooking.host;
    }
    return (
      <div className="page ps-row">
        <ModalManager whichModal={whichModal} toggleModal={this.toggleModal}>
          <OvertimeErrorModal
            ref="overtimeModal"
            bookingID={booking._id}
            overtimeError={modalErrorMsg}
          />
        </ModalManager>
        <div className="col-xs-12 margin-lg-top">
          <h3>
            <FormattedMessage
              id='inbox_bookingID_overtime.booking_overtime_main.report'
              defaultMessage='Report Overtime'
            />
          </h3>
        </div>
        <div className="col-md-8">
          <div className="overtime-form-container margin-lg-top margin-lg-bottom">
            <div>
              <FormattedMessage
                id='inbox_bookingID_overtime.booking_overtime_main.guest_overtime'
                defaultMessage='Let us know if your guest owes overtime fees for this booking. You can learn more in our {link}.'
                values={{
                  link: <a href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/206210506-What-happens-if-a-guest-stays-past-the-end-of-their-booking`} target="_blank" rel="noopener noreferrer">
                    <FormattedMessage
                      id='inbox_bookingID_overtime.booking_overtime_main.overtime_policy'
                      defaultMessage='Overtime Policy'
                    />
                  </a>
                }}
              />&nbsp;
              <FormattedMessage
                id='inbox_bookingID_overtime.booking_overtime_main.report_damages'
                defaultMessage='If you need to report damages or other charges, {link}.'
                values={{
                  link: <a href={`https://docs.google.com/forms/d/e/1FAIpQLSenxfTsoKFzFHDV-ELOO9t_OXrySDfeDpSIyHI7dJiSQtnrOA/viewform?entry.1558453777=*%7C${booking._id}%7C*&entry.861850322&entry.1683446246&entry.1960798477`} target="_blank" rel="noopener noreferrer">
                    <FormattedMessage
                      id='inbox_bookingID_overtime.booking_overtime_main.click_here'
                      defaultMessage='click here'
                    />
                  </a>
                }}
              />
            </div>
            <BookingOvertimeForm
              {...this.props}
              currencyType={currency}
              submitOvertime={this.submitOvertime}
              submitOvertimeCb={this.submitOvertimeCb}
              isProcessing={isProcessing}
              displayError={displayError}
              prepareOvertime={this.prepareOvertime}
              priceValue={listingPrice}
              hostID={hostID}
            />
          </div>
          <button className="classic btn btn-gray-outline" style={{ maxWidth: 90 }} onClick={this.cancelAction}>
            <FormattedMessage
              id='inbox_bookingID_overtime.booking_overtime_main.cancel'
              defaultMessage='Cancel'
            />
          </button>
        </div>
        <div className="col-md-4 margin-lg-top margin-lg-bottom">
          <BookingSummary
            booking={activityDetailBooking}
            profile={profile}
            intl={intl}
          />
        </div>
      </div>
    );
  }
}

BookingOvertimeMain.propTypes = {
  booking: PropTypes.object,
  accessToken: PropTypes.string,
  intl: intlShape
};

BookingOvertimeMain.contextTypes = {
  router: PropTypes.object
};

exports.BookingOvertimeMain = injectIntl(BookingOvertimeMain);
